import { render, staticRenderFns } from "./AdminTableList.vue?vue&type=template&id=0f5b2dd7&scoped=true"
import script from "./AdminTableList.vue?vue&type=script&lang=js"
export * from "./AdminTableList.vue?vue&type=script&lang=js"
import style0 from "./AdminTableList.vue?vue&type=style&index=0&id=0f5b2dd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b2dd7",
  null
  
)

export default component.exports